import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "react-hot-toast";

import "./index.css";
import Router from "./page";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    {/* 全局弹出提示 */}
    <Toaster />
    {/* 路由 */}
    <Router />
  </BrowserRouter>
);
